import { isFunction, isObject } from 'lodash-es';

export interface IPropertyPath {
    path: string[];
    property: string;
}

export type primitiveType = string | boolean | number | null | undefined;
export type ComplexType = primitiveType | primitiveType[];
export type DataBindingType = string; //--> se contiene ".JSonData."
export type DataBindingPropertyType = { propertyName: string };
export type DataBindingPropertyTypeOrNumberOrNull = number | DataBindingPropertyType | null;

export function isPrimitiveType(x: any): x is primitiveType {
    const type = typeof x;

    return x === null || type === 'string' || type === 'number' || type === 'boolean' || type === 'undefined';
}

export function isRecord(field: unknown): field is Record<string, unknown> {
    return isObject(field) && !isFunction(field);
}

export function isDataBinding(x: any): x is DataBindingType {
    if (typeof x !== 'string') return false;

    if (x?.startsWith('Report.')) return true;

    return false;
}

export function isDataBindingProperty(x: any): x is DataBindingPropertyType {
    if (x && x['propertyName']) return true;

    return false;
}

export const isEmpty = (val: any): val is undefined | null => val === undefined || val === null;
export const isNotEmpty = <T>(val: T | undefined | null): val is T => !isEmpty(val);
